module.exports = __webpack_public_path__ + "img/info.2b6ce25e.svg";